// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-profil {
  width: max-content !important;
}
.sidebar-profil .MuiPaper-root {
  margin: 48px;
  position: static !important;
  border-right: none !important;
}
.sidebar-profil .active-link span {
  font-size: 18px;
  font-family: "Barlow";
  font-weight: 600;
  color: rgb(18, 16, 16);
}
.sidebar-profil .sub-sidebar {
  background-color: rgb(245, 245, 247) !important;
  min-height: 80vh;
}
.sidebar-profil .bottom-link {
  position: absolute;
  bottom: 0;
  color: #FB263B;
  border-bottom: none !important;
  font-size: 16px;
  font-family: "Barlow";
  font-weight: 600;
  text-decoration: underline;
}
.sidebar-profil .bottom-link span {
  font-size: 16px !important;
  font-family: "Barlow";
  font-weight: 600 !important;
  color: rgb(251, 38, 59) !important;
  width: 92px;
  height: 19px;
}
.sidebar-profil .MuiListItem-root {
  margin: 32px;
  padding: 0px !important;
  border-bottom: 1px solid rgb(234, 234, 234);
  width: auto;
}

.profil {
  border: 1px solid rgb(234, 234, 234);
  padding: 32px;
}

@media screen and (max-width: 873px) {
  .sidebar-profil .sub-sidebar {
    min-height: auto !important;
  }
  .sidebar-profil .bottom-link {
    position: inherit;
  }
  .w-sm-100 {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/profil/profil.scss","webpack://./src/assets/styles/colors.scss"],"names":[],"mappings":"AACA;EACI,6BAAA;AAAJ;AACI;EACI,YAAA;EACA,2BAAA;EACA,6BAAA;AACR;AAEI;EACI,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;AAAR;AAEI;EACK,+CAAA;EAED,gBAAA;AADR;AAII;EACI,kBAAA;EACA,SAAA;EACA,cCxBQ;EDyBR,8BAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,0BAAA;AAFR;AAGQ;EACI,0BAAA;EACA,qBAAA;EACA,2BAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;AADZ;AAII;EACI,YAAA;EACA,uBAAA;EACA,2CAAA;EACA,WAAA;AAFR;;AAKA;EACI,oCAAA;EACA,aAAA;AAFJ;;AAIA;EACI;IACI,2BAAA;EADN;EAGE;IACI,iBAAA;EADN;EAGE;IACI,sBAAA;EADN;AACF","sourcesContent":["@import '../../assets/styles/colors.scss';\n.sidebar-profil{\n    width: max-content !important;\n    .MuiPaper-root{\n        margin:48px;\n        position:static !important  ;\n        border-right:none !important;\n\n    }\n    .active-link span{\n        font-size: 18px;\n        font-family: \"Barlow\";\n        font-weight: 600;\n        color: rgba(18, 16, 16, 1); \n    }\n    .sub-sidebar{\n         background-color:rgba(245, 245, 247, 1) !important ;\n        //background-color: red;\n        min-height: 80vh;\n        \n    }\n    .bottom-link {\n        position: absolute;\n        bottom: 0;\n        color:$primary-color;\n        border-bottom: none !important;\n        font-size: 16px;\n        font-family: \"Barlow\";\n        font-weight: 600;\n        text-decoration: underline;\n        span{\n            font-size: 16px !important;\n            font-family: \"Barlow\";\n            font-weight: 600 !important;\n            color: rgba(251, 38, 59, 1) !important;\n            width: 92px;\n            height: 19px;\n        }\n    }\n    .MuiListItem-root{\n        margin: 32px;\n        padding: 0px !important;\n        border-bottom: 1px solid rgb(234, 234, 234);\n        width: auto;\n    }\n}\n.profil{\n    border: 1px solid rgba(234, 234, 234, 1);\n    padding: 32px;\n}\n@media screen and ( max-width:873px) {\n    .sidebar-profil .sub-sidebar{\n        min-height: auto !important;\n    }\n    .sidebar-profil .bottom-link{\n        position: inherit;\n    }\n    .w-sm-100{\n        width: 100% !important;\n    }\n    \n}","$primary-color: #FB263B;\n$primary-color-hover: #ED4E5C;\n$primary-color-press: #F499A1;\n$interaction-dark-bg:#fff;\n$hover-dark-bg:#D5D4D5;\n$press-dark-bg:#969596;\n$light-bg:#F5F5F7;\n$dark-bg:#2D2A2C;\n$text-color:#121010;\n$subText-color:#7D7779;\n$success:#7BBE6A;\n$error:#FF8A00;\n$input-bg:#FAFAFA;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
